<div class="modifier_cover pb-0">
  <h5>AMEND CALCULATION AND PLOT</h5>

  <div>
    <div class="form-group mb-3">
      <label class="mb-2 text-center d-block">
        <b>Standard</b>
      </label>
      <ng-container>
        <select class="form-select rounded-0" [ngModel]="standard" (ngModelChange)="onStandardChange($event)">
          <option *ngFor="let opt of isoTypeList" [ngValue]="opt.id">
            {{opt.title}}
          </option>
        </select>
      </ng-container>
    </div>
    <hr>
  </div>
  <div>
    <label class="mb-1 text-center d-block">
      <b>Exposure</b>
    </label>
    <div>
      <div class="form-group mb-3">
        <div class="btn-group btn-group  btn_switch_group" role="group" data-toggle="buttons">
          <label class="btn btn-secondary" [ngClass]="{'active': isCheckedExpo('1')}">
            <input type="radio" class="btn-check" name="exposure" [id]="1" autocomplete="off" [value]="1"
              [checked]="isCheckedExpo('1')" (click)="buttonSwitchClickExpo('1')"> Original
          </label>
          <label class="btn btn-secondary" [ngClass]="{'active': isCheckedExpo('2')}">
            <input type="radio" class="btn-check" name="exposure" [id]="2" autocomplete="off" [value]="2"
              [checked]="isCheckedExpo('2')" (click)="buttonSwitchClickExpo('2')"> Customised
          </label>
        </div>
      </div>
    </div>
    <div>
      <div class="form-group mb-3">
        <label class="mb-1 ">
          Notional dB(A) LEP’D Level exposed
        </label>
        <input type="number" [attr.min]="85" [attr.max]="125" class="form-control " [ngModel]="newDbValue"
          (ngModelChange)="onNotionalChange($event)" />
        <div *ngIf="hasErrorNotional()">
          <div class="errors_block">Input a value between 85 and 125</div>
        </div>
      </div>
      <div class="form-group mb-3">
        <label class="mb-1 ">
          Years Exposed to Noise
        </label>
        <input type="number" [attr.min]="1" [attr.max]="49" class="form-control " [ngModel]="yearsExposedToNoise"
          (ngModelChange)="onYearsExposedToNoiseChange($event)" />
        <div *ngIf="hasErrorYearsExposedToNoise()">
          <div class="errors_block">Input a value between 1 and 49. 1st digit will be used for the subsequent
            calculation.</div>
        </div>
      </div>
    </div>
    <hr>
  </div>
  <div>
    <k-tabs>
      <k-tab [label]="'Right'">
        <div class="row">
          <div class="col-12">
            <app-form2 (formChanges)="rightModifierUpdated($event)" [audiometryInput]="audiometryInput"
              [presetFilters]="presetFilters?.right" [ageCentile]="ageCentile.right" [earType]="'right'"></app-form2>
          </div>
        </div>
      </k-tab>
      <k-tab [label]="'Left'">
        <div class="row">
          <div class="col-12">
            <app-form2 (formChanges)="leftModifierUpdated($event)" [audiometryInput]="audiometryInput"
              [presetFilters]="presetFilters?.left" [ageCentile]="ageCentile.left" [earType]="'left'"></app-form2>
          </div>
        </div>
      </k-tab>
    </k-tabs>
  </div>
</div>